import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { Add } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import SalaryModal from 'modules/job_catalog/components/SalaryModal'
import { formatSalary, getSalaryFrequencyText } from 'modules/job_catalog/lib/salaryUtils'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { recordIsSalary, useSalaryPage } from './useSalaryPage'

const SalariesPage = () => {
  const { rootId, familyId, functionId, roleId, levelId } = useParams()
  const id = levelId || roleId || functionId || familyId || rootId || ''

  const {
    source,
    nodeName,
    nodeType,
    selectedWorkplaces,
    hasAllWorkplacesSalary,
    editSalary,
    handleCreateSalary,
    handleUpdateSalary,
    showSalaryModal,
    setShowSalaryModal,
  } = useSalaryPage(id)

  return (
    <ResponsivePage.Body variant="full">
      <Box paddingTop="s20">
        <OneDataCollection
          source={source}
          emptyStates={{
            'no-data': {
              emoji: '💰',
              title: i18n.t('job_catalog.nodes.empty_state.salaries.title'),
              description: i18n.t('job_catalog.nodes.empty_state.salaries.description'),
              actions: [
                {
                  label: i18n.t('job_catalog.nodes.empty_state.salaries.actions.new'),
                  onClick: () => setShowSalaryModal(true),
                  icon: Add,
                },
              ],
            },
          }}
          visualizations={[
            {
              type: 'table',
              options: {
                columns: [
                  {
                    label: i18n.t('job_catalog.nodes.salaries.workplace'),
                    render: (record) => {
                      if (!recordIsSalary(record)) return
                      if (record.workplaces && record.workplaces.length > 0) {
                        return {
                          type: 'tagList',
                          value: {
                            type: 'raw',
                            tags: record.workplaces.map((workplace) => ({
                              text: workplace.name,
                            })),
                            max: 2,
                          },
                        }
                      } else {
                        return {
                          type: 'text',
                          value: i18n.t('job_catalog.nodes.salaries.all_workplaces'),
                        }
                      }
                    },
                  },
                  {
                    label: i18n.t('job_catalog.nodes.salary'),
                    render: (record) => {
                      if (!recordIsSalary(record)) return
                      return {
                        type: 'text',
                        value: formatSalary(record),
                      }
                    },
                  },
                  {
                    label: i18n.t('job_catalog.nodes.salaries.frequency'),
                    render: (record) => {
                      if (!recordIsSalary(record)) return
                      return {
                        type: 'text',
                        value: getSalaryFrequencyText(record.periodicity),
                      }
                    },
                  },
                ],
                frozenColumns: 1,
              },
            },
          ]}
        />
      </Box>
      {showSalaryModal && (
        <SalaryModal
          onClose={() => setShowSalaryModal(false)}
          name={nodeName}
          createAction={handleCreateSalary}
          updateAction={handleUpdateSalary}
          onSubmit={() => setShowSalaryModal(false)}
          nodeType={nodeType}
          initialSalary={editSalary}
          alreadySelectedWorkplaces={selectedWorkplaces}
          hasAllWorkplacesSalary={hasAllWorkplacesSalary}
        />
      )}
    </ResponsivePage.Body>
  )
}
export default SalariesPage
